import { useQuery } from '@tanstack/react-query';
import type { ApiClients } from '@/api/client';
import type { components } from '@/api/types/api-gateway';

// S2 Fleet — sites read hook. Powers the Map view (one canvas per
// site) and pre-fills the asset-create site dropdown.
export type Site = components['schemas']['Site'];

export function useSites(clients: ApiClients) {
  return useQuery({
    queryKey: ['sites', 'list'],
    queryFn: async (): Promise<Site[]> => {
      const { data, error } = await clients.apiGateway.GET('/v1/sites');
      if (error || !data) {
        const msg = (error as { error?: string } | undefined)?.error ?? 'sites failed';
        throw new Error(msg);
      }
      return data.items ?? [];
    },
    staleTime: 60_000,
  });
}
